import React from 'react';

function HeroBodySkeleton() {
  return (
    <div
      role="status"
      className="w-full flex flex-col items-center animate-pulse"
    >
      <div
        className="
          h-2
          md:h-4
          lg:h-5
          xl:h-6
          bg-gray-200
          rounded-full
          dark:bg-gray-700
          w-full
          max-w-[840px]
          mb-4"
      />
      <div
        className="
          h-2
          md:h-4
          lg:h-5
          xl:h-6
          bg-gray-200
          rounded-full
          dark:bg-gray-700 w-full
          max-w-[340px]
          md:max-w-[440px]
          lg:max-w-[540px]
          xl:max-w-[640px] mb-2.5"
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default HeroBodySkeleton;
